/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Mapping_DescriptionInputs */

const en_story_bank_mapping_description = /** @type {(inputs: Story_Bank_Mapping_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See which stories match each job requirement and identify gaps.`)
};

const de_story_bank_mapping_description = /** @type {(inputs: Story_Bank_Mapping_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See which stories match each job requirement and identify gaps.`)
};

const fr_story_bank_mapping_description = /** @type {(inputs: Story_Bank_Mapping_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See which stories match each job requirement and identify gaps.`)
};

const es_story_bank_mapping_description = /** @type {(inputs: Story_Bank_Mapping_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See which stories match each job requirement and identify gaps.`)
};

const it_story_bank_mapping_description = /** @type {(inputs: Story_Bank_Mapping_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See which stories match each job requirement and identify gaps.`)
};

const nl_story_bank_mapping_description = /** @type {(inputs: Story_Bank_Mapping_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See which stories match each job requirement and identify gaps.`)
};

const pl_story_bank_mapping_description = /** @type {(inputs: Story_Bank_Mapping_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See which stories match each job requirement and identify gaps.`)
};

const fi_story_bank_mapping_description = /** @type {(inputs: Story_Bank_Mapping_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See which stories match each job requirement and identify gaps.`)
};

const da_story_bank_mapping_description = /** @type {(inputs: Story_Bank_Mapping_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See which stories match each job requirement and identify gaps.`)
};

const sv_story_bank_mapping_description = /** @type {(inputs: Story_Bank_Mapping_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See which stories match each job requirement and identify gaps.`)
};

/**
* | output |
* | --- |
* | "See which stories match each job requirement and identify gaps." |
*
* @param {Story_Bank_Mapping_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_mapping_description = /** @type {((inputs?: Story_Bank_Mapping_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Mapping_DescriptionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_mapping_description(inputs)
	if (locale === "fr") return fr_story_bank_mapping_description(inputs)
	if (locale === "es") return es_story_bank_mapping_description(inputs)
	if (locale === "it") return it_story_bank_mapping_description(inputs)
	if (locale === "nl") return nl_story_bank_mapping_description(inputs)
	if (locale === "pl") return pl_story_bank_mapping_description(inputs)
	if (locale === "fi") return fi_story_bank_mapping_description(inputs)
	if (locale === "da") return da_story_bank_mapping_description(inputs)
	if (locale === "sv") return sv_story_bank_mapping_description(inputs)
	return en_story_bank_mapping_description(inputs)
});